module.exports = __webpack_public_path__ + "714d45e4e65e508bf8edf162df0d803c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/ribbons/smilies/2.png
// module id = 3431
// module chunks = 0